<app-modal-header
  (close)="close()">
  <span slot="title">{{ title ?? "" | translate }}</span>
</app-modal-header>


<div class="modal-body p-fluid">

  <app-auth
    [initEmail]="initEmail"
    [state]="state"
    [setRedirectAfterLoad]="setRedirectAfterLoad"
    (signedIn)="onSignedIn($event)">
  </app-auth>

</div>
